import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { EstudoResumo } from './estudo-resumo';
import { MatSnackBar } from '@angular/material';
import { EstudoService } from '../estudo/estudo.service';

@Component({
  templateUrl: './estudo-resumo.component.html',
  selector: 'estudo-resumo',
  styleUrls: ["estudo-resumo.component.css"]
})


export class EstudoResumoComponent implements OnInit {

  @Input() idEstudo: number;
  public resumo: EstudoResumo;
  public isLoading: boolean;

  constructor(private estudoService: EstudoService, private mensagem: MatSnackBar){

  }


  ngOnInit(){
    this.isLoading = true;
    this.estudoService.resumo(this.idEstudo).subscribe((result:EstudoResumo)=>{
      this.resumo=result;
      this.isLoading = false;
    },
     error => this.erro(error)
    );
  }


  private erro(erro: string): void{
    this.mensagem.open(erro, 'X', {duration: 5000});
    this.isLoading= false;
  }
}
